import React from "react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, subtitle, align = "left", light = false }) => {
  const alignClass = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignClass} max-w-3xl gap-4`}>
      {overline && (
        <Reveal>
          <span className="overline">{overline}</span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`font-head text-3xl md:text-5xl font-semibold tracking-tight ${light ? "text-navy" : "text-white"}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className={`text-base md:text-lg leading-relaxed ${light ? "text-slate-600" : "text-slate-400"}`}>
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeading;
